var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { tgfGraphics } from "../framework/tgfGraphics";
import { tbBase } from "./tbBase";
import { getPIXIObjectFromTbObject } from "./tbGetPIXIObject";
import { tbGraphics } from "./tbGraphics";
import { PIXI } from "./tbPIXI";
export var defaultFontPadding = 10;
var tbVectorFont = /** @class */ (function (_super) {
    __extends(tbVectorFont, _super);
    function tbVectorFont(fontFace, fallbackFontFace) {
        var _this = _super.call(this) || this;
        _this.anchorX = 0;
        _this.anchorY = 0;
        _this.text = "";
        _this.fontFace = fontFace;
        _this.fallbackFontFace = fallbackFontFace;
        _this.setDefault();
        _this.font = new PIXI["Text"]();
        _this.x = 0;
        _this.y = 0;
        _this.rotation = 0;
        return _this;
    }
    tbVectorFont.prototype.setDefault = function () {
        // Font
        this.fontStyle = "";
        this.fontWeight = "";
        this.fontCase = "normal";
        this.fontSize = 12;
        // Fill
        this.fill = true;
        this.fillAlpha = 1;
        this.fillMode = 0;
        this.fillColor = "black";
        this.fillPattern = { image: undefined, subImage: 0, repeatH: true, repeatV: true };
        this.fillGradient = { vertical: true, number: 3, colors: ["red", "white", "blue"], size: 0.6, offset: 0 };
        this.fillStyle = undefined;
        // Stroke
        this.stroke = false;
        this.strokeAlpha = 1;
        this.strokeMode = 0;
        this.strokeColor = "black";
        this.strokeStyle = undefined;
        this.strokeWidth = 0.0;
        this.strokeBehind = false;
        this.strokeJoin = "miter";
        // Shadow
        this.shadow = { active: false, color: "rgba(10, 10, 10, 0.3)", offsetX: 3, offsetY: 3, blur: 1 };
        // Text Alignment
        this.align = "left";
        this.baseline = "top";
        this.offsetFactor = 0;
        this.spacing = 0;
        this.padding = defaultFontPadding;
        // Wrap
        this.wordWrap = false;
        this.wordWrapWidth = 100;
        this.breakWords = false;
    };
    tbVectorFont.prototype.setProperties = function (properties) {
        if (properties === void 0) { properties = {}; }
        if (!properties.padding) {
            properties.padding = defaultFontPadding;
        }
        // Font Face
        if (properties.fontFace !== undefined) {
            this.fontFace = properties.fontFace;
        }
        if (properties.fallbackFontFace !== undefined) {
            this.fallbackFontFace = properties.fallbackFontFace;
        }
        // Font
        if (properties.fontStyle !== undefined) {
            this.fontStyle = properties.fontStyle;
        }
        if (properties.fontWeight !== undefined) {
            this.fontWeight = properties.fontWeight;
        }
        if (properties.fontCase !== undefined) {
            this.fontCase = properties.fontCase;
        }
        if (properties.fontSize !== undefined) {
            this.fontSize = properties.fontSize;
        }
        // Fill
        if (properties.fill !== undefined) {
            this.fill = properties.fill;
        }
        if (properties.fillAlpha !== undefined) {
            this.fillAlpha = properties.fillAlpha;
        }
        if (properties.fillColor !== undefined) {
            this.fillMode = 0;
            this.fillColor = properties.fillColor;
        }
        if (properties.fillPattern !== undefined) {
            this.fillMode = 1;
            this.fillPattern = properties.fillPattern;
        }
        if (properties.fillGradient !== undefined) {
            this.fillMode = 2;
            this.fillGradient = properties.fillGradient;
        }
        if (properties.fillStyle !== undefined) {
            this.fillMode = 3;
            this.fillStyle = properties.fillStyle;
        }
        // Stroke
        if (properties.stroke !== undefined) {
            this.stroke = properties.stroke;
        }
        if (properties.strokeAlpha !== undefined) {
            this.strokeAlpha = properties.strokeAlpha;
        }
        if (properties.strokeColor !== undefined) {
            this.strokeMode = 0;
            this.strokeColor = properties.strokeColor;
        }
        if (properties.strokeStyle !== undefined) {
            this.strokeMode = 3;
            this.strokeStyle = properties.strokeStyle;
        }
        if (properties.strokeWidth !== undefined) {
            this.strokeWidth = properties.strokeWidth;
        }
        if (properties.strokeBehind !== undefined) {
            this.strokeBehind = properties.strokeBehind;
        }
        if (properties.strokeJoin !== undefined) {
            this.strokeJoin = properties.strokeJoin;
        }
        // Shadow
        if (properties.shadow !== undefined) {
            this.shadow = properties.shadow;
        }
        // Text Alignment
        if (properties.align !== undefined) {
            this.align = properties.align;
        }
        if (properties.baseline !== undefined) {
            this.baseline = properties.baseline;
        }
        if (properties.offsetFactor !== undefined) {
            this.offsetFactor = properties.offsetFactor;
        }
        if (properties.spacing !== undefined) {
            this.spacing = properties.spacing;
        }
        if (properties.wordWrap !== undefined) {
            this.wordWrap = properties.wordWrap;
        }
        if (properties.wordWrapWidth !== undefined) {
            this.wordWrapWidth = properties.wordWrapWidth;
        }
        if (properties.breakWords !== undefined) {
            this.breakWords = properties.breakWords;
        }
        if (properties.padding !== undefined) {
            this.padding = properties.padding;
        }
        else {
            this.padding = 2;
        }
        this.style = new PIXI["TextStyle"](this.textStyle());
        this.font["setStyle"](this.style);
        this.setAnchorAlign();
        this.setAnchorBaseline();
    };
    tbVectorFont.prototype.textStyle = function () {
        if (this.shadow.active) {
            var x = this.shadow.offsetX;
            var y = this.shadow.offsetY;
            this.shadow.angle = Math.atan2(y, x);
            this.shadow.distance = Math.sqrt(x * x + y * y);
            this.shadow.alpha = this.shadow.alpha !== undefined ? this.shadow.alpha : 1;
        }
        else {
            this.shadow.angle = 0;
            this.shadow.distance = 0;
        }
        var style = {
            "fontFamily": this.fontFace,
            "fontStyle": this.fontStyle,
            "fontWeight": this.fontWeight,
            "fontVariant": this.fontCase,
            "fontSize": this.fontSize,
            "fill": this.fillColor,
            "stroke": this.strokeColor,
            "strokeThickness": this.strokeWidth,
            "lineJoin": this.strokeJoin,
            // Shadow
            "dropShadow": this.shadow.active,
            "dropShadowBlur": this.shadow.blur,
            "dropShadowColor": this.shadow.color,
            "dropShadowAngle": this.shadow.angle,
            "dropShadowDistance": this.shadow.distance,
            "dropShadowAlpha": this.shadow.alpha,
            // Wrap
            "wordWrap": this.wordWrap,
            "wordWrapWidth": this.wordWrapWidth,
            "breakWords": this.breakWords,
            // General
            "align": this.align,
            // "textBaseline" : this.baseline,
            "letterSpacing": this.spacing,
            "padding": this.padding
        };
        return style;
    };
    tbVectorFont.prototype.setStyle = function () {
        if (this.font) {
            this.font["setStyle"](this.textStyle());
            this.style = this.font["style"];
        }
    };
    tbVectorFont.prototype.setAnchorAlign = function () {
        if (!this.font) {
            return;
        }
        switch (this.align) {
            case "left":
                this.anchorX = 0;
                break;
            case "center":
                this.anchorX = 0.5;
                break;
            case "right":
                this.anchorX = 1;
                break;
        }
        this.font["anchor"]["set"](this.anchorX, this.anchorY);
    };
    tbVectorFont.prototype.setAnchorBaseline = function () {
        if (!this.font) {
            return;
        }
        switch (this.baseline) {
            case "top":
                this.anchorY = 0;
                break;
            case "middle":
                this.anchorY = 0.5;
                break;
            case "bottom":
                this.anchorY = 1;
                break;
        }
        this.font["anchor"]["set"](this.anchorX, this.anchorY);
    };
    tbVectorFont.prototype.setFontFace = function (fontFace) {
        this.fontFace = fontFace;
        this.setStyle();
    };
    tbVectorFont.prototype.getFontFace = function () {
        return this.fontFace;
    };
    tbVectorFont.prototype.setFallbackFontFace = function (fallbackFontFace) {
        this.fallbackFontFace = fallbackFontFace;
    };
    tbVectorFont.prototype.getFallbackFontFace = function () {
        return this.fallbackFontFace;
    };
    tbVectorFont.prototype.setFontStyle = function (fontStyle) {
        if (fontStyle === void 0) { fontStyle = ""; }
        this.fontStyle = fontStyle;
        this.setStyle();
    };
    tbVectorFont.prototype.getFontStyle = function () {
        return this.fontStyle;
    };
    tbVectorFont.prototype.setFontWeight = function (fontWeight) {
        if (fontWeight === void 0) { fontWeight = ""; }
        this.fontWeight = fontWeight;
        this.setStyle();
    };
    tbVectorFont.prototype.getFontWeight = function () {
        return this.fontWeight;
    };
    tbVectorFont.prototype.setFontCase = function (fontCase) {
        if (fontCase === void 0) { fontCase = "normal"; }
        this.fontCase = fontCase;
        this.setStyle();
    };
    tbVectorFont.prototype.getFontCase = function () {
        return this.fontCase;
    };
    tbVectorFont.prototype.setFontSize = function (fontSize) {
        if (fontSize === void 0) { fontSize = 12; }
        this.fontSize = fontSize;
        this.setStyle();
    };
    tbVectorFont.prototype.getFontSize = function () {
        return this.fontSize;
    };
    tbVectorFont.prototype.setFill = function (fill) {
        if (fill === void 0) { fill = true; }
        this.fill = fill;
        this.setStyle();
    };
    tbVectorFont.prototype.getFill = function () {
        return this.fill;
    };
    tbVectorFont.prototype.setFillAlpha = function (fillAlpha) {
        if (fillAlpha === void 0) { fillAlpha = 1; }
        this.fillAlpha = fillAlpha;
        this.setStyle();
    };
    tbVectorFont.prototype.getFillAlpha = function () {
        return this.fillAlpha;
    };
    tbVectorFont.prototype.setFillColor = function (color) {
        if (color === void 0) { color = "black"; }
        this.fillMode = 0;
        this.fillColor = color;
        this.setStyle();
    };
    tbVectorFont.prototype.getFillColor = function () {
        return this.fillColor;
    };
    tbVectorFont.prototype.setWordWrap = function (wordWrap, wordWrapWidth) {
        this.wordWrap = (wordWrap !== undefined) ? wordWrap : this.wordWrap;
        this.wordWrapWidth = wordWrapWidth ? wordWrapWidth : this.wordWrapWidth;
        this.setStyle();
    };
    tbVectorFont.prototype.getFillGradient = function () {
        return {
            vertical: this.fillGradient.vertical,
            number: this.fillGradient.number,
            colors: this.fillGradient.colors.slice(0),
            size: this.fillGradient.size,
            offset: this.fillGradient.offset
        };
    };
    tbVectorFont.prototype.getFillStyle = function () {
        return this.fillStyle;
    };
    tbVectorFont.prototype.setStroke = function (stroke) {
        if (stroke === void 0) { stroke = false; }
        this.stroke = stroke;
        this.setStyle();
    };
    tbVectorFont.prototype.getStroke = function () {
        return this.stroke;
    };
    tbVectorFont.prototype.setStrokeAlpha = function (alpha) {
        if (alpha === void 0) { alpha = 1; }
        this.strokeAlpha = alpha;
    };
    tbVectorFont.prototype.getStrokeAlpha = function () {
        return this.strokeAlpha;
    };
    tbVectorFont.prototype.setStrokeColor = function (color) {
        if (color === void 0) { color = "black"; }
        this.strokeMode = 0;
        this.strokeColor = color;
        this.setStyle();
    };
    tbVectorFont.prototype.getStrokeColor = function () {
        return this.strokeColor;
    };
    tbVectorFont.prototype.setStrokeStyle = function (style) {
        if (style === void 0) { style = "black"; }
        this.strokeMode = 3;
        this.strokeStyle = style;
        this.setStyle();
    };
    tbVectorFont.prototype.getStrokeStyle = function () {
        return this.strokeStyle;
    };
    tbVectorFont.prototype.setStrokeWidth = function (width) {
        this.strokeWidth = (width === undefined) ? 1 : width;
        this.setStyle();
    };
    tbVectorFont.prototype.getStrokeWidth = function () {
        return this.strokeWidth;
    };
    tbVectorFont.prototype.setStrokeBehind = function (behind) {
        if (behind === void 0) { behind = false; }
        this.strokeBehind = behind;
    };
    tbVectorFont.prototype.getStrokeBehind = function () {
        return this.strokeBehind;
    };
    tbVectorFont.prototype.setStrokeJoin = function (join) {
        this.strokeJoin = (join === undefined) ? "miter" : join;
        this.setStyle();
    };
    tbVectorFont.prototype.getStrokeJoin = function () {
        return this.strokeJoin;
    };
    tbVectorFont.prototype.setShadow = function (shadowProperties, color, offsetX, offsetY, blur) {
        if (shadowProperties === undefined) {
            this.shadow = { active: false, color: "rgba(10, 10, 10, 0.3)", offsetX: 3, offsetY: 3, blur: 1, angle: Math.PI / 6 };
        }
        else if (shadowProperties instanceof Object) {
            this.shadow = { active: shadowProperties.active, color: shadowProperties.color, offsetX: shadowProperties.offsetX, offsetY: shadowProperties.offsetY, blur: shadowProperties.blur, angle: shadowProperties.angle };
        }
        else if (color === undefined) {
            this.shadow.active = shadowProperties;
        }
        else {
            this.shadow = { active: shadowProperties, color: color, offsetX: offsetX, offsetY: offsetY, blur: blur, angle: Math.PI / 6 };
        }
        this.setStyle();
    };
    tbVectorFont.prototype.getShadow = function () {
        return { active: this.shadow.active, color: this.shadow.color, offsetX: this.shadow.offsetX, offsetY: this.shadow.offsetY, blur: this.shadow.blur, angle: this.shadow.angle };
    };
    tbVectorFont.prototype.setPadding = function (padding) {
        this.padding = padding;
        this.setStyle();
    };
    tbVectorFont.prototype.setAlign = function (align) {
        this.align = (align === undefined) ? "left" : align;
        this.setAnchorAlign();
    };
    tbVectorFont.prototype.getAlign = function () {
        return this.align;
    };
    tbVectorFont.prototype.setBaseline = function (baseline) {
        this.baseline = (baseline === undefined) ? "top" : baseline;
        this.setAnchorBaseline();
    };
    tbVectorFont.prototype.getBaseline = function () {
        return this.baseline;
    };
    tbVectorFont.prototype.setOffsetFactor = function (offsetFactor) {
        this.offsetFactor = (offsetFactor === undefined) ? 0 : offsetFactor;
        this.setStyle();
    };
    tbVectorFont.prototype.getOffsetFactor = function () {
        return this.offsetFactor;
    };
    tbVectorFont.prototype.setLineSpacing = function (spacing) {
        this.spacing = (spacing === undefined) ? 0 : spacing;
        this.setStyle();
    };
    tbVectorFont.prototype.getLineSpacing = function () {
        return this.spacing;
    };
    tbVectorFont.prototype.addChild = function (child) {
        if (!this.font) {
            console.error("Attempt to add a child on an invalid font", this);
        }
        child = getPIXIObjectFromTbObject(child);
        if (child) {
            this.font["addChild"](child);
        }
    };
    tbVectorFont.prototype.removeChild = function (child) {
        if (!this.font) {
            console.error("Attempt to remove a child on an invalid font", this);
        }
        child = getPIXIObjectFromTbObject(child);
        if (child) {
            this.font["removeChild"](child);
        }
    };
    tbVectorFont.prototype.add = function (container) {
        var obj;
        if (this.font) {
            obj = this.font;
        }
        else {
            console.log("No font attached");
        }
        if (obj) {
            if (container && container["addChild"]) {
                container["addChild"](obj);
            }
            else {
                tgfGraphics.addChild(obj);
            }
        }
    };
    tbVectorFont.prototype.remove = function (container) {
        var obj;
        if (this.font) {
            obj = this.font;
        }
        else {
            console.log("No font attached");
        }
        if (obj) {
            if (container && container["removeChild"]) {
                container["removeChild"](obj);
            }
            else {
                tgfGraphics.removeChild(obj);
            }
        }
    };
    tbVectorFont.prototype.free = function (alsoChildren) {
        if (alsoChildren === void 0) { alsoChildren = true; }
        if (this.font) {
            this.font["destroy"](alsoChildren);
            this.font = null;
        }
    };
    tbVectorFont.prototype.setText = function (text, upperCased) {
        if (upperCased === void 0) { upperCased = true; }
        // backwards compatibility
        if (text.substring(0, 9) === "lowercase") {
            var str = text.slice(9);
            this._setText(str);
        }
        else if (upperCased) {
            this._setText(text.toUpperCase());
        }
        else {
            this._setText(text);
        }
    };
    tbVectorFont.prototype._setText = function (text) {
        if (this.font && text) {
            this.text = text;
            this.font["setText"](text);
        }
    };
    tbVectorFont.prototype.setPosition = function (x, y) {
        var _a;
        this.x = x;
        this.y = y;
        (_a = this.font) === null || _a === void 0 ? void 0 : _a["position"]["set"](this.x, this.y);
    };
    tbVectorFont.prototype.setRotation = function (rotation) {
        this.rotation = rotation;
        if (this.font) {
            this.font["rotation"] = this.rotation;
        }
    };
    tbVectorFont.prototype.setAlpha = function (alpha) {
        if (this.font) {
            this.font["alpha"] = alpha;
        }
    };
    tbVectorFont.prototype.setScale = function (xScale, yScale) {
        if (this.font) {
            if (yScale === undefined) {
                yScale = xScale;
            }
            this.font["scale"]["set"](xScale, yScale);
        }
    };
    tbVectorFont.prototype.setWidth = function (width) {
        if (this.font) {
            this.font["width"] = width;
        }
    };
    tbVectorFont.prototype.setHeight = function (height) {
        if (this.font) {
            this.font["height"] = height;
        }
    };
    tbVectorFont.prototype.show = function () {
        if (this.font) {
            this.font["visible"] = true;
        }
    };
    tbVectorFont.prototype.hide = function () {
        if (this.font) {
            this.font["visible"] = false;
        }
    };
    tbVectorFont.prototype._getFontString = function () {
        return this.fontStyle + " " + this.fontWeight + " " + this.fontSize + "px " + this.fontFace + ", " + this.fallbackFontFace;
    };
    tbVectorFont.prototype._textWidth = function (lines) {
        var largestWidth = 0, li;
        for (li = 0; li < lines.length; li += 1) {
            largestWidth = Math.max(largestWidth, lines[li].width);
        }
        return largestWidth;
    };
    tbVectorFont.prototype._textHeight = function (lines) {
        return this.fontSize * lines.length + this.spacing * (lines.length - 1);
    };
    tbVectorFont.prototype._splitText = function (text, width) {
        var li, wi, currentLine, words, spaceWidth, wordWidth, currentWidth, lines, output = [];
        var context = tbGraphics.fontContext;
        context.font = this._getFontString();
        // Adapt case if required
        switch (this.fontCase) {
            case "upper":
                text = text.toUpperCase();
                break;
            case "lower":
                text = text.toLowerCase();
                break;
        }
        // Simple case
        if (width === undefined) {
            lines = text.split("\n");
            for (li = 0; li < lines.length; li += 1) {
                output.push({ text: lines[li], width: context.measureText(lines[li]).width });
            }
            return output;
        }
        // split on \n
        lines = text.split("\n");
        // split on width
        spaceWidth = context.measureText(" ").width;
        for (li = 0; li < lines.length; li += 1) {
            words = lines[li].split(" ");
            currentLine = words[0];
            currentWidth = context.measureText(words[0]).width;
            for (wi = 1; wi < words.length; wi += 1) {
                wordWidth = context.measureText(words[wi]).width;
                if (currentWidth + spaceWidth + wordWidth < width) {
                    currentLine += " " + words[wi];
                    currentWidth += spaceWidth + wordWidth;
                }
                else {
                    output.push({ text: currentLine, width: currentWidth });
                    currentLine = words[wi];
                    currentWidth = wordWidth;
                }
            }
            output.push({ text: currentLine, width: currentWidth });
        }
        return output;
    };
    tbVectorFont.prototype.textWidth = function (text) {
        text = text ? text : this.text;
        var w = PIXI["TextMetrics"]["measureText"](text, this.style, this.wordWrap);
        return w["width"];
    };
    tbVectorFont.prototype.textHeight = function (text) {
        text = text ? text : this.text;
        var h = PIXI["TextMetrics"]["measureText"](text, this.style, this.wordWrap);
        return h["height"];
    };
    tbVectorFont.prototype.lineInfo = function () {
        return PIXI["TextMetrics"]["measureText"](this.text, this.style, this.wordWrap);
    };
    tbVectorFont.prototype._textFitSize = function (size, text, width, height, split) {
        var oldSize = this.fontSize, lines, result;
        this.fontSize = size;
        if (split) {
            lines = this._splitText(text, width);
        }
        else {
            lines = this._splitText(text);
        }
        result = this._textWidth(lines) <= width && this._textHeight(lines) <= height;
        this.fontSize = oldSize;
        return result;
    };
    tbVectorFont.prototype.textFitSize = function (text, width, height, split) {
        var size = 0, increment = 32;
        if (split === undefined) {
            split = false;
        }
        tbGraphics.fontContext.save();
        while (this._textFitSize(size + increment, text, width, height, split)) {
            size += increment;
        }
        while (increment >= 2) {
            increment /= 2;
            if (this._textFitSize(size + increment, text, width, height, split)) {
                size += increment;
            }
        }
        tbGraphics.fontContext.restore();
        return Math.max(4, size);
    };
    tbVectorFont.prototype.clone = function () {
        var result = new tbVectorFont(this.fontFace, this.fallbackFontFace);
        // Font
        result.fontStyle = this.fontStyle;
        result.fontWeight = this.fontWeight;
        result.fontCase = this.fontCase;
        result.fontSize = this.fontSize;
        // Fill
        result.fill = this.fill;
        result.fillAlpha = this.fillAlpha;
        result.fillMode = this.fillMode;
        result.fillColor = this.fillColor;
        result.fillPattern = { image: this.fillPattern.image, repeatH: this.fillPattern.repeatH, repeatV: this.fillPattern.repeatV };
        result.fillGradient = { vertical: this.fillGradient.vertical, number: this.fillGradient.number, colors: this.fillGradient.colors.slice(0),
            size: this.fillGradient.size, offset: this.fillGradient.offset };
        result.fillStyle = this.fillStyle;
        // Stoke
        result.stroke = this.stroke;
        if (!result.stroke) {
            result.strokeWidth = 0;
        }
        result.strokeAlpha = this.strokeAlpha;
        result.strokeMode = this.strokeMode;
        result.strokeColor = this.strokeColor;
        result.strokeStyle = this.strokeStyle;
        result.strokeWidth = this.strokeWidth;
        result.strokeBehind = this.strokeBehind;
        result.strokeJoin = this.strokeJoin;
        // Shadow
        result.shadow = { active: this.shadow.active, color: this.shadow.color, offsetX: this.shadow.offsetX, offsetY: this.shadow.offsetY, blur: this.shadow.blur, angle: this.shadow.angle };
        // Text Alignment
        result.align = this.align;
        result.baseline = this.baseline;
        result.offsetFactor = this.offsetFactor;
        result.spacing = this.spacing;
        result.wordWrap = this.wordWrap;
        result.wordWrapWidth = this.wordWrapWidth;
        result.breakWords = this.breakWords;
        result.padding = this.padding;
        result.style = new PIXI["TextStyle"](result.textStyle());
        result.font["setStyle"](result.style);
        result.setAnchorAlign();
        result.setAnchorBaseline();
        return result;
    };
    return tbVectorFont;
}(tbBase));
export { tbVectorFont };
